<template>
  <div class="notif-wrapper" v-click-outside="hide">
    <button @click="nshow">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.2739 16.8692L16.8431 14.4842C16.1823 13.3834 15.8331 12.1225 15.8331 10.8392V8.75C15.8331 6.1125 14.0731 3.88168 11.6664 3.1625V1.66668C11.6664 0.7475 10.9189 0 9.99972 0C9.08054 0 8.33304 0.7475 8.33304 1.66668V3.1625C5.9264 3.88168 4.1664 6.1125 4.1664 8.75V10.8392C4.1664 12.1225 3.81722 13.3825 3.15722 14.4834L1.7264 16.8684C1.6489 16.9975 1.64722 17.1575 1.7214 17.2884C1.79558 17.4192 1.93308 17.5 2.08308 17.5H17.9164C18.0664 17.5 18.2047 17.4192 18.2789 17.2892C18.3531 17.1592 18.3506 16.9975 18.2739 16.8692Z" fill="#A9ECD0"/>
        <path d="M7.375 18.333C7.845 19.3147 8.84 19.9997 9.99914 19.9997C11.1583 19.9997 12.1533 19.3147 12.6233 18.333H7.375Z" fill="#A9ECD0"/>
        <circle cx="15" cy="8" r="5.5" fill="#F39220" stroke="#2CB181" v-if="newCircle"/>
      </svg>
    </button>
    <div class="notification-center" v-if="show">
      <div
          v-for="notification in notifications"
          class="notification"
          :class="{new: notification.new}"
          :key="'notif'+notification.id"
          @click="handle(notification.id, !notification.new)"
      >
        <div class="notification-header">
          <div class="title" v-if="!notification.url">
            {{notification.title}}
          </div>
          <div class="title" v-if="notification.url">
            <router-link :to="notification.url">
              {{notification.title}}
            </router-link>
          </div>
          <div class="date">
            {{notification.date}}
          </div>
        </div>
        <div class="notification-body">
          {{notification.body}}
        </div>
      </div>
      <div class="bottom" @click="history = true" v-show="!history">
        Посмотреть историю
      </div>
    </div>
  </div>

</template>

<script>

import echo from '../socket'

export default {
  name: "app-notifications",
  data: () => ({
    show: false,
    history: false,
    notification_data: [
    ]
  }),
  mounted() {
    this.getNotifications();
    if (localStorage.getItem('token')) {
      echo.private('App.User.' + localStorage.getItem('token'))
              .notification((notification) => {
                this.notification_data.unshift({
                  id: notification.id,
                  title: notification.title,
                  body: notification.body,
                  date: notification.date,
                  new: true,
                  url: notification.url
                });
              });
    }
  },
  computed: {
    notifications() {
      if(this.history) return this.notification_data;
      if(!this.history) return this.notification_data.slice(0,6)
      else return []
    },
    newCircle(){
      return this.notification_data.some(item => item.new) || false
    }
  },
  methods: {
    hide(){
      this.show = this.history = false
    },
    nshow(){
      this.show = true
    },
    handle(id, read){
      if (!read) {
        this.$http.post('/read-notification', {
          token: localStorage.getItem('token'),
          id: id
        }).then(({data}) => {
          if (data.success) {
            this.notification_data.map((item)=>{
              if(item.id == id){
                item.new = false
              }
              return item
            })
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
    getNotifications() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-notifications', {
          token: localStorage.getItem('token')
        }).then(({data}) => {
          if (data.notifications) {
            this.notification_data = [];
            for (let item in data.notifications) {
              this.notification_data.push({
                id: data.notifications[item].id,
                title: data.notifications[item].data.title,
                body: data.notifications[item].data.body,
                date: data.notifications[item].data.date,
                new: data.notifications[item].read_at ? false : true,
                url: data.notifications[item].data.url
              });
            }
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .notif-wrapper{
    position: relative;

    & > button {
      background: none;
      border: none;
      outline: none;
      margin: 0 10px;

    }

    & .notification-center{
      cursor: default;
      position: absolute;
      width: 450px;
      top:25px;
      margin-top: 13px;
      right: -100px;
      background: #FFFFFF;
      box-shadow: 0px 0px 30px rgba(129, 129, 129, 0.25);
      border-radius: 4px;
      padding: 20px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #7A818F;
      z-index: 500;
      max-height: 80vh;
      overflow: auto;

      &:before{
        content: "";
        position: absolute;
        width: 10px;
        height: 10px;
        top: -5px;
        right: 115px;
        background: #fff;
        transform: rotate(45deg);
      }
      & .notification{
        position: relative;
        padding: 10px 0;
        border-bottom: 1px solid #EEF0F3;
        text-align: left;
        cursor: pointer;

        &:first-child{
          padding-top: 0;
        }

        &.new {
          & .title:after{
            content: '';
            position: absolute;
            top: 5px;
            left: -10px;
            width: 4px;
            height: 4px;
            background-color: #F39220;
            border-radius: 100%;
          }
        }

        & .notification-header{
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;

          & .title{
            max-width: 300px;
            font-size: 14px;
            font-weight: 500;
            color: #2D3137;
          }

          & .date{
            align-self: flex-start;
            white-space: nowrap;
            width:  110px;
            line-height: 16px;
          }
        }

        & .notification-body{
          text-align: left;
        }
      }
      & .bottom{
        padding: 10px 5px 0 0;
        text-align: left;
      }

    }
  }


</style>
